// extracted by mini-css-extract-plugin
export default {"page":"style_page__jcRti","emoji":"style_emoji__-7asA","title":"style_title__+Hj3J","subtitle":"style_subtitle__UWW+P","spacer":"style_spacer__VMS1g"};